import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb } from "react-bootstrap";
import {
  categoryList,
  deleteTemplates,
  documentsList,
  editTemplates,
  updateTemplates,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/extra/loading";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { MenuItem, Select } from "@material-ui/core";

const Default = [
  {
    name: "Yes",
    id: "1",
  },
  {
    name: "No",
    id: "0",
  },
];

const ViewSProviderProfile = () => {
  const navigate = useNavigate();
  const EditId = location.pathname.split("/")[3];
  const dispatch = useDispatch();
  const [data, setData] = useState({
    name: "",
    documents: [],
    template_categories_id: "",
    template_categories_name: "",
    default_template: "",
  });

  const TemplatesData = useSelector((s) => s.Templates.templates?.data);
  const DocumentList = useSelector((s) => s.Documents.documents?.data);
  const Categories = useSelector((s) => s?.Categories?.categories?.data);
  const [isLoading, setLoading] = useState(false);
  const [tempId, setTempId] = useState([]);

  useEffect(() => {
    if (DocumentList) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [DocumentList]);

  useEffect(() => {
    if (TemplatesData) {
      setData((pre) => ({
        ...pre,
        name: TemplatesData.name,
        documents:
          TemplatesData.documents &&
          TemplatesData.documents.length > 0 &&
          TemplatesData.documents.map((item) => item.id),
        template_categories_id: JSON.stringify(
          TemplatesData?.template_categories_id
        ),
        template_categories_name: TemplatesData?.template_categories_name,
        default_template: TemplatesData?.default_template,
      }));
    }
  }, [TemplatesData]);

  useEffect(() => {
    dispatch(documentsList());
    dispatch(categoryList());
    dispatch(editTemplates(EditId));
  }, [EditId]);

  const handleChange = (e, valId) => {
    const { name, value } = e.target;
    if (name == "documents") {
      if (data.documents.includes(valId)) {
        let Doc = data.documents.filter((x) => x != valId);
        setData((pre) => ({ ...pre, documents: Doc }));
      } else {
        setData((pre) => ({ ...pre, documents: [...data.documents, valId] }));
      }
    } else if (valId == "cat") {
      let tempID = Categories.find((x) => x.name == value);
      setData((pre) => ({
        ...pre,
        template_categories_id: tempID.id,
        template_categories_name: value,
      }));
    } else if (valId == "def") {
      setData((pre) => ({ ...pre, [name]: value }));
    } else {
      setData((pre) => ({ ...pre, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const callBack = (res) => {
      if (res.status == 200) {
        toast.success("Updated Successfully!");
        navigate("/templates");
      }
    };
    dispatch(
      updateTemplates({ ...data, status: "1", editId: EditId }, callBack)
    );
  };

  const handleDeleteTemp = (e) => {
    e.preventDefault();
    const callBack = (res) => {
      if (res.data) {
        toast.success("Deleted Successfully!");
        navigate("/templates");
      }
    };
    dispatch(deleteTemplates(EditId, callBack));
  };

  return (
    <>
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/templates">Templates</Breadcrumb.Item>
                  <Breadcrumb.Item active>Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
          </Row>
          <div className="bg-white px-4 py-3 card-box">
            <Row>
              {/* <Col lg="12" className="text-end">
                <Button>Make as Default</Button>
              </Col> */}
              <Col lg="4" className="my-2">
                <label htmlFor="" className="form-label2 m-0">
                  Template Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={data.name}
                  placeholder=""
                  className="form-control"
                  onChange={handleChange}
                />
                <span className="note error_note py-2 m-0 text-danger">
                  {/* {errors.name} */}
                </span>
              </Col>
              <Col lg="4" className="my-2 doc-select">
                <label htmlFor="" className="form-label2 m-0">
                  Template Category
                </label>
                <Select
                  className="demo-simple-select-label"
                  id="demo-simple-select"
                  name="template_categories_name"
                  value={data.template_categories_name}
                  onChange={(e) => handleChange(e, "cat")}
                  MenuProps={Categories}
                >
                  {Categories &&
                    Categories.length > 0 &&
                    Categories.map((item, idx) => {
                      return (
                        <MenuItem key={item.id} value={item.name}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </Col>
              <Col lg="4" className="my-2 doc-select">
                <label htmlFor="" className="form-label2 m-0">
                  Make Default Template
                </label>
                <Select
                  className="demo-simple-select-label"
                  id="demo-simple-select"
                  name="default_template"
                  value={data.default_template}
                  onChange={(e) => handleChange(e, "def")}
                  MenuProps={Default}
                >
                  {Default &&
                    Default.length > 0 &&
                    Default.map((item, idx) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </Col>
            </Row>
            <div className="top my-3">
              <h4 className="dashboard-head m-0">Documents</h4>
            </div>
            <Row className="radio-wrp mt-3">
              {(!isLoading &&
                DocumentList &&
                DocumentList.length > 0 &&
                DocumentList.map((item, idx) => {
                  return (
                    <Col lg="4" sm="6" className="my-2 inner" key={idx}>
                      <div className="inner position-relative">
                        <input
                          type="checkbox"
                          name="documents"
                          className="position-absolute"
                          checked={
                            data?.documents && data?.documents.includes(item.id)
                          }
                          onChange={(e) => handleChange(e, item.id)}
                        />
                        <div className="radio-card shadow-sm border rounded px-3 ps-4 py-2 position-relative">
                          <p className="m-0 fw-sbold ps-2">{item.name}</p>
                        </div>
                      </div>
                    </Col>
                  );
                })) || (
                <div className="empty-loading">
                  <Loading />
                </div>
              )}
            </Row>
            <div className="pt-2">
              <Button
                onClick={handleSubmit}
                disabled={
                  data.documents?.length < 1 ||
                  data.name == "" ||
                  data.template_categories_id == ""
                    ? true
                    : false
                }
              >
                Submit
              </Button>
              <Button className="m-2 delete-btn" onClick={handleDeleteTemp}>
                Delete this template
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};
export default ViewSProviderProfile;
